import styled from 'styled-components'

export const Container = styled.div`
  height: 100vh;
`

export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`

export const Group = styled.div`
  display: flex;
`
